<header class="sfc-body sfc-display-flex sfc-flex-row sfc-justify-content-start">
  <h3 class="sfc-padding-100 sfc-justify-content-center sfc-heading-3 sfc-col-2">{{ pageTitle }}</h3>
      @for (route of routes; track $index) {
        <div class="sfc-body sfc-display-flex sfc-justify-content-center sfc-flex-row sfc-margin-inline-50">
          <sfc-item link="{{ route.path }}" icon-start="{{ getIcon(route.path)}}">
            <span slot="label">{{ route.data?.['title'] }}</span>{{route.path}}
          </sfc-item>
        </div>
      }
</header>
